import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Ajax from '@/lib/axios';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

import moment from 'moment'
Vue.prototype.$moment = moment;
moment.locale('zh-cn');

Vue.config.productionTip = false;
Vue.use(Antd);
Vue.prototype.$http = Ajax;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
